module.exports = __webpack_public_path__ + "img/vipkp.5ada877a.png";